module.exports = __webpack_public_path__ + "static/ebru-9297beb384b6af7cc0640ee81f2c692e.png";